import React from "react";
import { View, Text, StyleSheet, TouchableOpacity, Platform } from "react-native";
import { useSelector, useDispatch } from "react-redux";
import { Color, globalFontStyle } from "../assets";
import {
  back_arrow,
  backArrow,
  logo,
  share_button,
  WhatsApp,
  back_arrow_white,
  gift,
  coin,
  account_home,
} from "../utils/images";
import { useNavigation } from "@react-navigation/native";
import FastImage from "../common/FastImage";
import {
  globalConfigurableData,
  globalConst,
  GlobalScreens,
} from "../utils/globalConstant";
import { globalImport } from "../common/globalImports";
import { Button } from "../components/core/Button";
import DropDownProfile from "./Forms/dropDownProfile";
import { getLoginRoute, isMobile, openURL, showLoginModal } from "../utils/commonMethods";
import { logout } from "../utils/logOut";
import { navigationReset } from "../navigation/rootNavigation";
import Colors from "../assets/Color/Colors";
import { convert } from "../locale/translateText";
import { Icon } from '@iconify/react';

const Header = ({
  isInternalPage = true,
  pageName,
  isBackgroundColor = true,
  popTO = 1,
  shareMethod,
  selected,
  backGroundColor,
  isBackBtnCallback = null,
  customHeaderText = null,
  isProTrader = false,
  isCheckGoBack = false,
  onHTTClick = null,
  children,
  contestBalance,
  translate = false,
  accountRedirect = () => { },
  httTitle,
  isLeftImage,
  isShowBackIcon = true,
}) => {
  const navigation = useNavigation();
  const dispatch = useDispatch();
  const isAppLogin = useSelector(({ utilReducer }) => utilReducer.isAppLogin);
  const globalConfigData = useSelector(
    state => state.utilReducer.globalConfigData,
  );
  const telegramLink = globalConfigData?.telegramLink;

  const onProTraderClick = () => {
    navigation.navigate("ProTrader");
  };

  const onDropdownSelect = value => {
    if (value === "Profile") {
      navigation.navigate("Profile");
    } else if (value === "Join Telegram") {
      if (telegramLink) {
        openURL(telegramLink);
      }
    } else if (value === "Log Out") {
      logout();
    }
  };

  const list = ["Profile", "Join Telegram", "Log Out"];

  const onLoginClick = () => {
    showLoginModal(dispatch);
  };

  return (
    <View
      style={[
        styles.headerContainer,
        backGroundColor
          ? { backgroundColor: backGroundColor }
          : pageName && isBackgroundColor
            ? { backgroundColor: "rgba(10, 87, 255, 0.03)" }
            : { backgroundColor: globalConfigurableData.headerColor },
      ]}>
      {isInternalPage ? (
        <>
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
            }}>
            <TouchableOpacity
              onPress={() => {
                navigationReset();
              }}>
              <FastImage
                style={styles.logo}
                source={globalConfigurableData?.logoUrl()}
              />
            </TouchableOpacity>
          </View>
          {isMobile() ? (
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              {isAppLogin ? (
                <>
                  {GlobalScreens.Account.showAccount && (
                    <>
                      {isProTrader && (
                        <View style={{ marginRight: 10 }}>
                          <Button
                            variant="outline"
                            size="sm"
                            onPress={onProTraderClick}
                            style={styles.proTraderButton}
                            leftIcon={true}
                            translate
                          >
                            Pro Trader
                          </Button>
                        </View>
                      )}
                      {GlobalScreens.Home.howToTrade && (
                      <Button
                          variant="outline"
                          size="sm"
                          onPress={onHTTClick}
                          className="header-button"
                          translate
                        >
                          How To Play
                        </Button>
                      )}
                    </>
                  )}
                </>
              ) : (
                <Button
                  variant="primary"
                  size="default"
                  onPress={onLoginClick}
                  style={{
                    flex: globalImport.isWeb ? {} : 0,
                    paddingVertical: 10,
                    paddingHorizontal: 15,
                    minHeight: 40,
                    minWidth: 60,
                    borderRadius: globalConfigurableData.btnBorderRadius,
                  }}
                  className="header-login-button"
                >
                  {globalConfigurableData.authButtonText}
                </Button>
              )}
            </View>
          ) : (
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              <Text
                onPress={() => {
                  if (!isAppLogin) {
                    onLoginClick();
                  } else {
                    navigation.navigate("Home");
                  }
                }}
                style={[
                  selected === "Markets"
                    ? {
                      color: globalConfigurableData.switchTabSelectedColor,
                      marginRight: "30px",
                    }
                    : {
                      color: globalConfigurableData.switchTabUnselectedColor,
                      marginRight: "30px",
                    },
                  globalFontStyle.appFontSubHeading,
                ]}>
                {convert("Markets")}
              </Text>
              <Text
                onPress={() => {
                  if (!isAppLogin) {
                    onLoginClick();
                  } else {
                    navigation.navigate("Portfolio");
                  }
                }}
                style={[
                  selected === "Portfolio"
                    ? {
                      color: globalConfigurableData.switchTabSelectedColor,
                      marginRight: "30px",
                    }
                    : {
                      color: globalConfigurableData.switchTabUnselectedColor,
                      marginRight: "30px",
                    },
                  globalFontStyle.appFontSubHeading,
                ]}>
                {convert("Portfolio")}
              </Text>
              <Text
                onPress={() => {
                  if (!isAppLogin) {
                    onLoginClick();
                  } else {
                    navigation.navigate("Wallet");
                  }
                }}
                style={[
                  selected === "Wallet"
                    ? {
                      color: globalConfigurableData.switchTabSelectedColor,
                      marginRight: "30px",
                    }
                    : {
                      color: globalConfigurableData.switchTabUnselectedColor,
                      marginRight: "30px",
                    },
                  globalFontStyle.appFontSubHeading,
                ]}>
                {convert("Wallet")}
              </Text>
              <Text
                onPress={() => {
                  if (!isAppLogin) {
                    onLoginClick();
                  } else {
                    navigation.navigate("Activity");
                  }
                }}
                style={[
                  selected === "Activity"
                    ? {
                      color: globalConfigurableData.switchTabSelectedColor,
                      marginRight: "30px",
                    }
                    : {
                      color: globalConfigurableData.switchTabUnselectedColor,
                      marginRight: "30px",
                    },
                  globalFontStyle.appFontSubHeading,
                ]}>
                {convert("Activity")}
              </Text>
              {globalConfigData?.isLiveTradeShow && (
                <Text
                  onPress={() => {
                    window.open(globalConfigData?.liveTradeUrl);
                  }}
                  style={[
                    selected === "Live"
                      ? { color: Color.black, marginRight: "30px" }
                      : { color: Color.lightgrey, marginRight: "30px" },
                    globalFontStyle.appFontSubHeading,
                  ]}>
                  {"Live"}
                </Text>
              )}
              {isAppLogin ? (
                <>
                  {GlobalScreens.Account.showAccount && (
                    <DropDownProfile
                      selectedData="Profile"
                      onValueChange={onDropdownSelect}
                      pickerlist={list}
                      isProfile={true}
                    />
                  )}
                </>
              ) : (
                <Button
                  variant="primary"
                  size="default"
                  onPress={onLoginClick}
                  style={{
                    flex: globalImport.isWeb ? {} : 0,
                    paddingVertical: 10,
                    paddingHorizontal: 15,
                    minHeight: 40,
                    minWidth: 60,
                    borderRadius: globalConfigurableData.btnBorderRadius,
                  }}
                  className="header-login-button"
                >
                  {globalConfigurableData.authButtonText}
                </Button>
              )}
            </View>
          )}
        </>
      ) : (
        <View style={{ flexDirection: "row", alignItems: "center", flex: 1 }}>
          {isShowBackIcon ? (
            <TouchableOpacity
              onPress={() => {
                if (isBackBtnCallback) {
                  isBackBtnCallback(false);
                } else {
                  if (!navigation.canGoBack() && isCheckGoBack) {
                    navigation.navigate("Home");
                  } else {
                    navigation.pop(popTO);
                  }
                }
              }}>
              <Icon 
                icon="tabler:arrow-left"
                style={styles.backIcon}
                color={globalConfigurableData.primaryTextColor1}
                width="24"
                height="24"
              />
            </TouchableOpacity>
          ) : null}
          {pageName && (
            <Text
              style={[
                globalFontStyle.appFontEventTitle,
                {
                  color: globalConfigurableData.primaryTextColor1,
                  marginLeft: 10,
                },
                customHeaderText,
              ]}>
              {translate ? convert(pageName) : pageName}
            </Text>
          )}
          <View style={{ flex: 1 }} />
          {contestBalance && (
            <View style={styles.balButton}>
              <FastImage
                style={{ width: 18, height: 18, marginRight: 5 }}
                source={globalConfigurableData.coin()}
              />
              <Text
                style={{ ...globalFontStyle.appFontBody, color: Colors.black }}>
                {contestBalance}
              </Text>
            </View>
          )}
          {onHTTClick && GlobalScreens.Home.howToTrade && (
            <Button
              variant="outline"
              size="sm"
              onPress={onHTTClick}
              style={{
                flex: globalImport.isWeb ? {} : 0,
                paddingVertical: 5,
                paddingHorizontal: 15,
                borderRadius: 20,
                marginRight: 15,
                flexDirection: "row",
              }}
              leftIcon={isLeftImage}
              translate
            >
              {httTitle || "How To Play"}
            </Button>
          )}
          {Platform.OS === "web" && shareMethod !== undefined ? children : null}
        </View>
      )}
    </View>
  );
};

export default Header;

const styles = StyleSheet.create({
  headerContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 16,
    height: 64,
    alignItems: "center",
    backgroundColor: Colors.bgWhite,
    ...(!isMobile() && {
      borderBottomColor: "rgba(0, 0, 0, 0.04)",
      borderBottomWidth: 1,
    }),
    top: 0,
    position: globalImport?.isWeb ? "sticky" : "absolute",
    zIndex: 1000,
  },
  backBtnStyle: {
    width: 24,
    height: 24,
  },
  shareBtnStyle: {
    width: 24,
    height: 24,
  },
  proTraderButton: {
    flex: 0,
    backgroundColor: Colors.bgWhite,
    borderColor: Colors.black,
    paddingHorizontal: 10,
    borderRadius: 16,
    borderWidth: 0.5,
    paddingVertical: 5,
    flexDirection: "row",
  },
  balButton: {
    borderColor: Colors.black,
    paddingHorizontal: 10,
    borderRadius: 100,
    borderWidth: 0.75,
    paddingVertical: 6,
    marginRight: 15,
    flexDirection: "row",
    alignItems: "center",
  },
  logo: {
    height: 52,
    width: 156,
    objectFit: 'contain',
  },
  backIcon: {
    width: 24,
    height: 24,
  },
});
